import {
  getLearningSelectedGroupsFromLocalStorage,
  getLearningSelectedLevelFromLocalStroage,
  getLearningSortTypeFromLocalStorage,
} from "../settings/learningSettings";
import { LearningType } from "./LearningType";

export class LearningContinueRequest {
  learningType: number;
  learningGroup: string;
  learningLevel: string;
  seed: number;
  sort: string;
  itemSize: number;
  currentIndex: number;
  currentPage: number;

  constructor(
    learningType: LearningType,
    seed: number,
    itemSize: number,
    currentIndex: number,
    currentPage: number
  ) {
    let learningTypeIntValue = 0;
    switch (learningType) {
      case LearningType.flashcards:
        learningTypeIntValue = 1;
        break;
      case LearningType.multiplechoice:
        learningTypeIntValue = 2;
        break;
      case LearningType.spellingQuiz:
        learningTypeIntValue = 3;
        break;
    }

    this.learningType = learningTypeIntValue;
    this.learningGroup = getLearningSelectedGroupsFromLocalStorage()
      .map((group: { title: string }) =>
        group.title === "no_group" ? "" : group.title
      )
      .join(",");
    this.learningLevel = getLearningSelectedLevelFromLocalStroage().join(",");
    this.seed = seed;
    this.sort = getLearningSortTypeFromLocalStorage();
    this.itemSize = itemSize;
    this.currentIndex = currentIndex;
    this.currentPage = currentPage;
  }
}
